import { Injectable } from '@angular/core';
import { IesHttpClient } from '../../../Common/ies-http-client.service';
import { AppUrl } from '../../../Common/appUrl';


@Injectable()
export class AdmRemoveOfficeService {
  
  constructor(private _httpClient: IesHttpClient) {   
  }

  //Add Office Record
  replaceOffice(params: any) {
     return this._httpClient.post(AppUrl.replaceOffice,params);    
  }

  //Add Office Record
  deleteOffice(id: number) {
    let param = { officeId: id };
    return this._httpClient.post(AppUrl.deleteOffice,param);   
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-office/adm-remove-office/adm-remove-office.service.ts